import { useQuery } from '@tanstack/react-query';
import { voicesApi } from '../services/voicesApi';
import type { VoiceQuery } from '@troia-v3/types';

export const useVoices = (query?: VoiceQuery) => {
  return useQuery({
    queryKey: ['voices', query],
    queryFn: () => voicesApi.getAll(query),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
